import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import { LanguageStore } from "src/stores";
import { inject, observer } from "mobx-react";
import { ISettings } from "src/models";
import { isBrowser } from "src/libs/utils";

export interface DynamicLinkProps {
  settings: ISettings;
  to: string;
  [x: string]: any;
  languageStore?: LanguageStore;
}
@inject("languageStore")
@observer
class DLink extends React.Component<DynamicLinkProps> {
  render() {
    const { to, settings, className, languageStore, ...rest } = this.props;
    const { generalSettings } = settings;
    const { siteUrl } = generalSettings;

    const { currentLanguage } = languageStore;
    let prefix = "";
    if (to === "/" && currentLanguage?.slug !== "en") {
      prefix = "/" + currentLanguage?.slug;
    } else if (isBrowser() && window.location.pathname.split("/").length < 2) {
      prefix = "/" + `${currentLanguage?.slug}`;
    }

    const toWithPrefix = prefix + to;

    if (toWithPrefix === null) {
      return <a tabIndex={0} {...rest} />;
    }

    if (toWithPrefix && toWithPrefix.startsWith("/wp-content")) {
      return (
        <a href={siteUrl} target="_blank" className={className} tabIndex={0} {...rest} />
      );
    }

    if (toWithPrefix && toWithPrefix.includes(process.env.GATSBY_WP_BASE_URL)) {
      let redirectUrl = toWithPrefix.replace(
        process.env.GATSBY_WP_BASE_URL,
        process.env.GATSBY_WP_FRONTEND_URL
      );
      return <Link to={redirectUrl} className={className} {...rest} />;
    }

    if (toWithPrefix && toWithPrefix.startsWith("/")) {
      return <Link to={toWithPrefix} className={className} {...rest} />;
    }

    return <a href={toWithPrefix} className={className} tabIndex={0} {...rest} />;
  }
}

export const DynamicLink = ({ to, ...rest }) => (
  <StaticQuery
    query={query}
    render={data => {
      return <DLink to={to} settings={data.siteSettings} {...rest} />;
    }}
  />
);

const query = graphql`
  query {
    ...siteSettingsFragment
  }
`;
